import { c as _c } from "react/compiler-runtime";
import { Logo, LogoProps } from './logo.tsx';
export const LogoEmptySearch: React.FC<LogoProps> = t0 => {
  const $ = _c(13);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M198.653 166.076C223.228 123.511 208.642 69.0751 166.076 44.5C123.511 19.9249 69.0751 34.5109 44.5 77.0763C19.9249 119.642 34.5109 174.077 77.0763 198.653C119.642 223.228 174.077 208.642 198.653 166.076Z" fill="#EFF5FF" />;
    t2 = <path d="M156.757 58.5764H88.3957C81.8679 58.5764 76.5762 63.8901 76.5762 70.445V161.708C76.5762 168.263 81.8679 173.576 88.3957 173.576H156.757C163.284 173.576 168.576 168.263 168.576 161.708V70.445C168.576 63.8901 163.284 58.5764 156.757 58.5764Z" fill="white" />;
    t3 = <path d="M158.227 70H88.773C86.6892 70 85 84.103 85 101.5C85 118.897 86.6892 133 88.773 133H158.227C160.311 133 162 118.897 162 101.5C162 84.103 160.311 70 158.227 70Z" fill="#D5D5D5" />;
    t4 = <path d="M154.95 141.576H88.2022C86.1996 141.576 84.5762 142.919 84.5762 144.576C84.5762 146.233 86.1996 147.576 88.2022 147.576H154.95C156.953 147.576 158.576 146.233 158.576 144.576C158.576 142.919 156.953 141.576 154.95 141.576Z" fill="#D5D5D5" />;
    t5 = <path d="M154.95 154.576H88.2022C86.1996 154.576 84.5762 155.919 84.5762 157.576C84.5762 159.233 86.1996 160.576 88.2022 160.576H154.95C156.953 160.576 158.576 159.233 158.576 157.576C158.576 155.919 156.953 154.576 154.95 154.576Z" fill="#D5D5D5" />;
    t6 = <path fillRule="evenodd" clipRule="evenodd" d="M148.214 178.543C157.826 178.543 166.76 175.643 174.185 170.682L204.561 199.576L215.576 186.836L186.268 158.953C191.679 151.36 194.866 142.078 194.866 132.06C194.866 106.386 173.984 85.5764 148.221 85.5764C122.458 85.5764 101.576 106.386 101.576 132.06C101.576 157.734 122.458 178.543 148.221 178.543H148.214ZM188 132.06C188 153.792 170.319 171.411 148.512 171.411C126.705 171.411 109.024 153.792 109.024 132.06C109.024 110.328 126.705 92.7088 148.512 92.7088C170.319 92.7088 188 110.328 188 132.06Z" fill="#192B59" />;
    t7 = <path d="M147.576 172.576C170.22 172.576 188.576 154.665 188.576 132.576C188.576 110.487 170.22 92.5764 147.576 92.5764C124.932 92.5764 106.576 110.487 106.576 132.576C106.576 154.665 124.932 172.576 147.576 172.576Z" fill="#EFF5FF" />;
    t8 = <path d="M155.419 132.076L165.178 122.353C166.095 121.391 166.591 120.111 166.576 118.786C166.561 117.462 166.021 116.204 165.081 115.264C164.142 114.331 162.869 113.791 161.538 113.776C160.206 113.762 158.919 114.257 157.949 115.168L148.169 124.891L138.41 115.168C137.944 114.672 137.374 114.28 136.753 114.006C136.124 113.732 135.451 113.584 134.77 113.577C134.089 113.569 133.409 113.695 132.773 113.947C132.136 114.206 131.567 114.583 131.078 115.064C130.597 115.545 130.213 116.115 129.954 116.744C129.695 117.373 129.569 118.046 129.576 118.727C129.584 119.408 129.732 120.074 130.006 120.703C130.279 121.324 130.679 121.887 131.175 122.353L140.948 132.076L131.175 141.799C130.679 142.265 130.279 142.828 130.006 143.449C129.732 144.071 129.584 144.744 129.576 145.425C129.569 146.106 129.695 146.779 129.954 147.408C130.213 148.037 130.59 148.607 131.078 149.088C131.559 149.569 132.136 149.946 132.773 150.205C133.409 150.464 134.082 150.59 134.77 150.575C135.458 150.56 136.131 150.42 136.753 150.146C137.382 149.872 137.944 149.48 138.41 148.984L148.191 139.261L157.972 148.984C158.948 149.835 160.213 150.294 161.515 150.25C162.817 150.205 164.053 149.672 164.97 148.762C165.888 147.845 166.42 146.616 166.457 145.321C166.494 144.026 166.036 142.768 165.17 141.799L155.412 132.076H155.419Z" fill="#1D46D8" />;
    t9 = <path d="M204.576 198.898L215.333 186.576L216.951 188.101C218.525 189.583 219.465 191.647 219.567 193.856C219.669 196.057 218.926 198.215 217.504 199.847C216.076 201.48 214.087 202.458 211.966 202.566C209.845 202.674 207.768 201.905 206.201 200.423L204.583 198.898H204.576Z" fill="#192B59" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] !== props) {
    t10 = <Logo width="244" height="244" viewBox="0 0 244 244" fill="none" {...props}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</Logo>;
    $[11] = props;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
};